export const currencies = {
    AAVE: {
        currencyId: "AAVE",
        currencyDesc: "AaveCoin(AAVE)",
        dbName: "db_trade_aave",
        currencySymbol: "AAVEUSDT",
        currencySocket: "aaveusdt@kline_1m",
        currencyType: "CRYPTO"
    },
    ASTR: {
        currencyId: "ASTR",
        currencyDesc: "ASTAR(ASTR)",
        dbName: "db_trade_astr",
        currencySymbol: "ASTRUSDT",
        currencySocket: "astrusdt@kline_1m",
        currencyType: "CRYPTO"
    },
    ALGO: {
        currencyId: "ALGO",
        currencyDesc: "Algorand(ALGO)",
        dbName: "db_trade_algo",
        currencySymbol: "ALGOUSDT",
        currencySocket: "algousdt@kline_1m",
        currencyType: "CRYPTO"
    },
    CAKE: {
        currencyId: "CAKE",
        currencyDesc: "CAKE",
        dbName: "db_trade_cake",
        currencySymbol: "CAKEUSDT",
        currencySocket: "cakeusdt@kline_1m",
        currencyType: "CRYPTO"
    },
    CVX: {
        currencyId: "CVX",
        currencyDesc: "CVX",
        dbName: "db_trade_cvx",
        currencySymbol: "CVXUSDT",
        currencySocket: "cvxusdt@kline_1m",
        currencyType: "CRYPTO"
    },
    CHZ: {
        currencyId: "CHZ",
        currencyDesc: "Chiliz(CHZ)",
        dbName: "db_trade_chz",
        currencySymbol: "CHZUSDT",
        currencySocket: "chzusdt@kline_1m",
        currencyType: "CRYPTO"
    },
    GRT: {
        currencyId: "GRT",
        currencyDesc: "The Graph(GRT)",
        dbName: "db_trade_grt",
        currencySymbol: "GRTUSDT",
        currencySocket: "grtusdt@kline_1m",
        currencyType: "CRYPTO"
    },
    TRX: {
        currencyId: "TRX",
        currencyDesc: "Tron(TRX)",
        dbName: "db_trade_trx",
        currencySymbol: "TRXUSDT",
        currencySocket: "trxusdt@kline_1m",
        currencyType: "CRYPTO"
    },
    XTZ: {
        currencyId: "XTZ",
        currencyDesc: "Tezos(XTZ)",
        dbName: "db_trade_xtz",
        currencySymbol: "XTZUSDT",
        currencySocket: "xtzusdt@kline_1m",
        currencyType: "CRYPTO"
    }
}

const extraProps = {
    permanentTransactionsData: {
        data: [],
        rowsLength: 0
    },
    tempTransactionsData: {
        data: [],
        rowsLength: 0
    },
    probabilityTransactionsData: {
        data: [],
        rowsLength: 0
    },
    waveLevels: {
        buyWave: 0,
        sellWave: 0
    },
    realTimeStatus: {
        candleClosePrice: null,
        entrySide: ""
    },
    totalStatus: {
        activePosition: "",
        lastPositionProfit: null,
        accumulativeProfit: null
    },
    operations: {
        isRenkoCreationOn: false,
        isModelOn: false,
        isBinanceOn: false,
        isTradeOn: false
    },
    approach: {
        approachId: 1
    },
    tradeMethod: {
        methodId: 1
    },
    interestType: {
        interestId: 0
    },
    isChartDataFormatRenko: true,
    renkoData: {
        slingshot1: [],
        slingshot2: [],
        wavetrend1: [],
        wavetrend2: [],
        moving_average1: [],
        moving_average2: [],
        moving_average3: [],
        moving_average4: [],
        moving_average5: [],
        date_time: [],
        mainRenkoData: [],
        subRenkoData: []
    },
    BUY: {
        walletConfig: {
            quantity: 1,
            marginType: "ISOLATED",
            takeProfit: 1,
            stopLoss: -1,
            rechargePercent: 0,
            leverage: 1,
            maxStopLossLimit: 0,
            maxResistanceLevelPrice: 0,
            minSupportLevelPrice: 0,
            priceLengthAverage: 0,
            renkoStartDate: ""
        },
        currencyConfigs: {
            renkoPipes: 0,
            timeFrame: 0,
            distanceMoving: 0,
            startRenko: 0,
            strategyType: 1,
            emaValueFastRenko: 0,
            emaValueSlowRenko: 0,
            mastep1: 0,
            mastep2: 0,
            mastep3: 0,
            mastep4: 0,
            mastep5: 0,
            waveEma1: 0,
            waveEma2: 0,
            upperBoundRangePercentage: 0,
            lowerBoundRangePercentage: 0
        }
    },
    SELL: {
        walletConfig: {
            quantity: 1,
            marginType: "ISOLATED",
            takeProfit: 1,
            stopLoss: -1,
            rechargePercent: 0,
            leverage: 1,
            maxStopLossLimit: 0,
            maxResistanceLevelPrice: 0,
            minSupportLevelPrice: 0,
            priceLengthAverage: 0,
            renkoStartDate: ""
        },

        currencyConfigs: {
            renkoPipes: 0,
            timeFrame: 0,
            distanceMoving: 0,
            emaValueFastRenko: 0,
            emaValueSlowRenko: 0,
            mastep1: 0,
            mastep2: 0,
            mastep3: 0,
            mastep4: 0,
            mastep5: 0,
            waveEma1: 0,
            waveEma2: 0,
            startRenko: 0,
            strategyType: 1,
            upperBoundRangePercentage: 0,
            lowerBoundRangePercentage: 0
        }
    }
};

for (let index in currencies) {
    currencies[index] = {
        ...currencies[index],
        ...extraProps
    }
}





